// @flow

import { observer } from "mobx-react";
import React from "react";

import Modal from "app/components/Modal/Modal";

import "./ConfirmationModal.scss";

type Props = {
    message: string,
    actionText?: string,
    cancelText?: string,
    onConfirm: Function,
    onCancel: Function
};

@observer
export default class ConfirmationModal extends React.Component<Props> {
    render() {
        const footer = this.renderFooter();

        return (
            <div className="ConfirmationModal">
                <Modal footer={footer} onCancel={this.props.onCancel}>
                    {this.props.message}
                </Modal>
            </div>
        );
    }

    renderFooter() {
        return (
            <footer>
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={this.props.onCancel}
                >
                    {this.props.cancelText || "Cancel"}
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.props.onConfirm}
                >
                    <i className="fa fa-check" />{" "}
                    {this.props.actionText || "Confirm"}
                </button>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ConfirmationModal/ConfirmationModal.js